<!-- The Task Modal -->
<div class="modal fade" id="taskeditmodal">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title h3">{{ "projecttask.edittask" | trans }}</h4>
        <button type="button" class="close" (click)="closeModal()">
          &times;
        </button>
      </div>
      <div class="modal-body">
        <app-loadconfirm *ngIf="showSpinner" [text]="'projecttask.loadconfirmsave' | trans"
          [icon]="'pending'"></app-loadconfirm>
        <form>
          <div class="form-group">
            <label class="font-weight-light f-15 mb-0" for="tasktitle{{ task.taskId }}">{{ "projecttask.title" | trans
              }}</label>
            <input required type="text" class="form-control stageinput" id="tasktitle{{ task.taskId }}"
              aria-describedby="tasktitleHelp" name="title" [(ngModel)]="modalTask.title" required />
          </div>
          <div class="form-group mb-0 p-0">
            <label class="font-weight-light f-15 mb-0" for="taskdescription{{ task.taskId }}">{{
              "projecttask.description" | trans }}</label>
          </div>
          <div class="form-group">
            <quill-editor theme="snow" [modules]="modules" [formats]="formats" id="taskdescription{{ task.taskId }}"
              class="w-100 taskedit-quill" name="description" [(ngModel)]="modalTask.description">
              <p>{{ "projecttask.descriptionplace" | trans }}</p>
            </quill-editor>
          </div>

          <!---- Task responsible start---->
          <div class="form-group">
            <label class="font-weight-light f-15 mb-0" for="taskresponsible{{ task.taskId }}">{{
              "projecttask.responsible" | trans }}</label>
            <select required class="taskresponsible form-control taskresoption" id="taskresponsible{{ task.taskId }}"
              name="responsible" [(ngModel)]="modalTask.responsible" required>
              <optgroup *ngIf="
                  modalTask.responsible &&
                  modalTask.responsible.substr(0, 4) === 'role'
                " label="From template">
                <option class="taskresoption" [ngValue]="modalTask.responsible">
                  <h6 class="taskresoption">{{ modalTask.responsible }}</h6>
                </option>
              </optgroup>
              <optgroup label="Organization">
                <option class="taskresoption" *ngFor="let member of projectMembers" [ngValue]="member.personId"
                  required>
                  <h6 class="taskresoption">{{ member.fullname }}</h6>
                </option>
              </optgroup>
              <optgroup label="Customer">
                <option class="taskresoption" *ngFor="let member of projectCustomerMembers"
                  [ngValue]="member.userId.substr(0, 36)" required>
                  <h6 class="taskresoption">{{ member.fullname }}</h6>
                </option>
              </optgroup>
            </select>
          </div>
          <div *ngIf="willLoseAccess()" class="form-group rounded p-1 bg-lightgrey">
            <div class="row">
              <div class="col">
                <h6 class="ml-1">{{ "projecttask.warning" | trans }}</h6>
              </div>
            </div>
            <div class="row">
              <div class="col-8">
                <label class="ml-1 font-weight-light f-15 mb-0" for="taskwarning{{ task.taskId }}">
                  {{ "projecttask.warningmsg" | trans }}</label>
              </div>
              <div class="col-2">
                <input required type="checkbox" class="form-control w-30 mt-2 ml-3" id="taskwarning{{ task.taskId }}"
                  name="taskwarning" [(ngModel)]="acceptwarning" />
              </div>
            </div>
          </div>
          <!---- Task responsible end---->
          <div class="form-group">
            <label class="font-weight-light mb-0 f-13" for="tasktype">{{
              "projectstage.tasktypeheader" | trans
              }}</label>
            <select class="form-control" id="tasktype" name="tasktype" [(ngModel)]="modalTask.tasktype" required
              disabled>
              <option [ngValue]="'task'">
                {{ "projectstage.tasktypetask" | trans }}
              </option>
              <option [ngValue]="'event'">
                {{ "projectstage.tasktypeevent" | trans }}
              </option>
              <option [ngValue]="'submit'">
                {{ "projectstage.tasktypesubmit" | trans }}
              </option>
              <option [ngValue]="'download'">
                {{ "projectstage.tasktypedownload" | trans }}
              </option>
              <option [ngValue]="'link'">
                {{ "projectstage.link" | trans }}
              </option>
              <option [ngValue]="'form'">
                {{ "projectstage.tasktypeform" | trans }}
              </option>
            </select>
          </div>
          <!---Form Template Selector (when tasktype='form') start--->
          <div *ngIf="modalTask.tasktype === 'form'" class="form-group">
            <label class="font-weight-light f-15 mb-0" for="formtemplate{{ task.taskId }}">
              {{ "projecttask.formtemplate" | trans }}
            </label>
            
            <!-- Loading state -->
            <div *ngIf="loadingForms" class="text-muted">
              <span class="spinner-border spinner-border-sm mr-2"></span>
              {{ "projecttask.loadingforms" | trans }}
            </div>
            
            <!-- Form selector -->
            <select *ngIf="!loadingForms && hasPublishedForms" 
                    class="form-control" 
                    id="formtemplate{{ task.taskId }}"
                    name="formTemplateId" 
                    [(ngModel)]="modalTask.formTemplateId"
                    (ngModelChange)="onFormSelected()"
                    required>
              <option [ngValue]="null">{{ "projecttask.selectform" | trans }}</option>
              <option *ngFor="let form of publishedForms" [ngValue]="getFormKey(form)">
                {{ form.name }} (v{{ form.version }})
              </option>
            </select>
            
            <!-- Empty state -->
            <div *ngIf="!loadingForms && !hasPublishedForms" class="alert alert-warning">
              <p class="mb-0">{{ "projecttask.nopublishedforms" | trans }}</p>
              <small>{{ "projecttask.publishformsfirst" | trans }}</small>
            </div>
          </div>
          <!---Form Template Selector end--->
          <!---Download condition fied start---->
          <div *ngIf="modalTask.tasktype == 'download'" class="form-group mb-0">
            <div class="row">
              <div class="form-group col">
                <label class="font-weight-light f-15 mb-0" for="linkurl{{ task.taskId }}">{{ "projectstage.downloadlink"
                  | trans }}</label>
                <input (change)="validate()" required type="url" class="form-control" id="linkurl{{ task.taskId }}"
                  name="warning" [(ngModel)]="modalTask.linkurl" />
              </div>
            </div>
            <div class="row">
              <div class="form-group col">
                <label class="font-weight-light f-15 mb-0" for="linktext{{ task.taskId }}">{{
                  "projectstage.downloadtext" | trans }}</label>
                <input (change)="validate()" required type="text" class="form-control" id="linktext{{ task.taskId }}"
                  name="linktext" [(ngModel)]="modalTask.linktext" />
              </div>
            </div>
          </div>
          <!---Download condition fied end---->
          <!---Link condition fied start---->
          <div *ngIf="modalTask.tasktype == 'link'" class="form-group">
            <div class="row">
              <div class="form-group col">
                <label class="font-weight-light f-15 mb-0" for="linkurl{{ task.taskId }}">{{ "projectstage.linkurl" |
                  trans }}</label>
                <input (change)="validate()" required type="text" class="form-control" id="linkurl{{ task.taskId }}"
                  name="warning" [(ngModel)]="modalTask.linkurl" />
              </div>
            </div>
            <div class="row">
              <div class="form-group col">
                <label class="font-weight-light f-15 mb-0" for="linktext{{ task.taskId }}">{{ "projectstage.linktext" |
                  trans }}</label>
                <input (change)="validate()" required type="text" class="form-control" id="linktext{{ task.taskId }}"
                  name="linktext" [(ngModel)]="modalTask.linktext" />
              </div>
            </div>
          </div>

          <!---Upload/download condition field start--->
          <div *ngIf="modalTask.tasktype === 'submit'" class="form-group">
            <ul class="list-group">
              <li *ngFor="
                  let value of modalTask.uploadFields;
                  let i = index;
                  let last = last;
                  trackBy: trackByIndex
                " class="list-group-item">
                <div class="input-group">
                  <input [(ngModel)]="modalTask.uploadFields[i]" [name]="'fileheader_' + i" type="text"
                    class="form-control" [placeholder]="'projectstage.filetitleheader' | trans" />

                  <!-- add file -->
                  <div *ngIf="last" (click)="addFileInput()" class="input-group-append">
                    <span class="input-group-text">
                      <span class="material-icons align-middle lh-20 p-0 w-20 h-20 f-20 cursor-pointer">add</span>
                    </span>
                  </div>

                  <!-- remove file -->
                  <div *ngIf="!last" (click)="removeFileInput(i)" class="input-group-append">
                    <span class="input-group-text">
                      <span class="material-icons align-middle lh-20 p-0 w-20 h-20 f-20 cursor-pointer">close</span>
                    </span>
                  </div>
                </div>
              </li>
            </ul>
          </div>

          <!---Upload/download condition field end--->
          <!----Event condition field---->
          <div *ngIf="modalTask.tasktype == 'event'" class="form-group">
            <label class="font-weight-light f-15 mb-0" for="taskstartdate{{ task.taskId }}">{{ "projecttask.eventstart"
              | trans }}</label>
            <input required type="datetime-local" class="form-control stageinput" id="taskstartdate{{ task.taskId }}"
              name="stardate" [(ngModel)]="modalTask.startdate" required />
          </div>
          <div *ngIf="modalTask.tasktype == 'event'" class="form-group">
            <label class="font-weight-light f-15 mb-0" for="taskduedate{{ task.taskId }}">{{ "projecttask.eventend" |
              trans }}</label>
            <input required type="datetime-local" class="form-control stageinput" id="taskduedate{{ task.taskId }}"
              name="duedate" [(ngModel)]="modalTask.duedate" required />
          </div>
          <!----Event condition field end---->
          <div *ngIf="modalTask.tasktype != 'event'" class="form-group">
            <label class="font-weight-light f-15 mb-0" for="taskstartdate{{ task.taskId }}">{{ "projecttask.startdat" |
              trans }}</label>
            <input required type="date" class="form-control stageinput" id="taskstartdate{{ task.taskId }}"
              name="stardate" [(ngModel)]="modalTask.startdate" required />
          </div>
          <div *ngIf="modalTask.tasktype != 'event'" class="form-group">
            <label class="font-weight-light f-15 mb-0" for="taskduedate{{ task.taskId }}">{{ "projecttask.duedat" |
              trans }}</label>
            <input required type="date" class="form-control stageinput" id="taskduedate{{ task.taskId }}" name="duedate"
              [(ngModel)]="modalTask.duedate" required />
          </div>
          <div *ngIf="!isCustomer" class="form-group">
            <label class="font-weight-light f-15 mb-0" for="vendorswitch{{ task.taskId }}">{{ "projecttask.visibility" |
              trans }}</label>
            <select required class="form-control stageinput" id="vendorswitch{{ task.taskId }}" name="taskvisibility"
              [(ngModel)]="modalTask.taskvisibility" required>
              <option [ngValue]="'shared'">
                {{ "projecttask.shared" | trans }}
              </option>
              <option [ngValue]="'vendor_only'">
                {{ "projecttask.vendoronly" | trans }}
              </option>
            </select>
          </div>
          <!---- Time tracking (timereg org module), existing tasks only ---->
          <app-time-tracking-panel *ngIf="timeregEnabled && task?.taskId"
            [taskId]="task.taskId" [projectId]="task.projectId"></app-time-tracking-panel>
          <div *ngIf="errorMessage != null" class="alert alert-danger ml-0 mr-0">
            <h6 class="error-msg mb-0">{{ errorMessage | trans }}</h6>
          </div>
          <div class="row">
            <div class="col">
              <button type="button" class="btn-close float-left w-100" (click)="closeModal()">
                <h6 class="btn-save-text">{{ "projecttask.close" | trans }}</h6>
              </button>
            </div>
            <div class="col">
              <button [disabled]="willLoseAccess() && !acceptwarning" type="button" class="btn-save float-right w-100"
                (click)="saveTask()">
                <h6 class="btn-save-text">{{ "projecttask.save" | trans }}</h6>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<app-alertbox *ngIf="taskeditalert" [@inbgOutAnimation] [alerticon]="'check_circle'" [alerttype]="'success'"
  [alerttext]="'taskeditmodal.succesalert' | trans"></app-alertbox>